module.exports = __webpack_public_path__ + "media/images/logo-819b2a1d75f99a0b7dac27c9cc2ccece.png";